import React from "react"
  import {
    Container,
    Col,
    Row} from 'reactstrap';
    import {isMobile} from 'react-device-detect';
    import Database from "./database/Database"
    import { Waypoint } from 'react-waypoint';

    
    class Part4 extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                mobile:isMobile,
                count:0,
            }
            this.handleWin = this.handleWin.bind(this); 
            this.handleQuestion6 = this.handleQuestion6.bind(this);
 
          }

          handleQuestion6(param){
            this.setState({
                figure6: param,
                feedback6: true
            });
            const scriptURL =
              `https://script.google.com/macros/s/AKfycby0kfnJ_QpsQFxjE5yUYoUvN1V--LIaCU5Yk4CjjnSMS7b6PyM/exec?overall=${0}&question1=${0}&question2=${0}&question3=${0}&question4=${param}&question0=${0}`;
            fetch(scriptURL)
              .then(response => console.log("Success!", response))
              .catch(error => console.error("Error!", error.message));
        }
          handleWin(){
            this.setState(prevState => {
                return {count: 1}
            })}

            handleArabic(){
              this.setState(prevState => {
                  return {notArabic: !prevState.notArabic}
              })}

        render()
        {
            let textselect6= this.state.mobile?<p style={{opacity:this.state.feedback6?0:1}} className="aliagray text-center">TAP TO SELECT</p>:<p style={{opacity:this.state.feedback6?0:1}}className="aliagray text-center">CLICK TO SELECT</p>;
            let thankyou6=this.state.feedback6?<p className="text-center font-600 pad20 display-5">Thank you for your feedback</p>:<p className="text-center font-600 pad20 display-5">&nbsp;</p>
  let feedquestion6 = this.state.feedback6?<Row>
<Col xs="6"><div className={`${this.state.figure6==="1" ? 'choiceselected' : ''}`}><p className="text-center display-4">YES</p></div></Col>
<Col xs="6"><div className={`${this.state.figure6==="1" ? 'choiceselected' : ''}`}><p className="text-center display-4">NO</p></div></Col>
  </Row>:
  <Row>
      <Col xs="6"><div onClick={() => { this.handleQuestion6('1') }} className="choiceselect"><p className="text-center display-4">YES</p></div></Col>
      <Col xs="6"><div onClick={() => { this.handleQuestion6('2') }} className="choiceselect"><p className="text-center display-4">NO</p></div></Col>
 </Row>

let winlosecases = this.state.count===1? <iframe src="https://ourworldindata.org/grapher/covid-confirmed-daily-deaths-epidemiological-trajectory" frameBorder='0' title="framea" scrolling='no' style={{width:"100%",height:"600px"}}></iframe>:<p></p>

            return (
                <div>
                <Container fluid><h2 className="text-center newsection"><span className="display-2 home-4">PART FIVE</span></h2>
                </Container>
                    <Container id="howquickly" fluid>
                        <Container>
                            <Row className="justify-content-center align-items-center">
                                <Col lg="10" xs="12" className="text-left no-padding">
                                <p className="display-2 aliagray home-2 text-center">
                                Are we winning or losing the fight?
                                    </p>
                                    <p>
                                    The question on a lot of people's minds right now is how do we measure if things are getting better or worse each day?
                                    </p>
                                    <p><span className="font600">
                                    One way is to compare the weekly rolling averages.
                                    </span>
                                    </p>
                                    <p>
                                    This allows you to see if the number of new infections this week was higher or lower than last week. 
                                    </p>
                                    <br/>
                                <Waypoint onEnter={()=> {this.handleWin()}}/>  
                                <div style={{backgroundColor:"rgba(185,211,211,0.2)", padding:"10px"}}>
                                {winlosecases}
                                <br/>
                                <br/>
                                <Row className="boxcard">
                                    <Col xl="6" xs="12"  className="text-left">
                                    <section>
                                    <p className="font-600 display-5">
                                    Questions this chart answers:
                                    </p>
                                    <br/>
                                    <p>
                                    <span className="font600">Q. Is my country getting better or worse?</span>
                                    </p>
                                    <p>
                                    A. Select your country from the menu on the bottom left. If the graph is trending downwards, then the rate of deaths is decreasing. If the graph is trending upwards, then the rate is increasing.
                                    </p>
                                    <p>
                                    <span className="font600">Q. Why is my country not included?</span>
                                    </p>
                                    <p>
                                    A. This graph only shows countries that have reported at least five deaths.
                                    </p>
                                    <br/>
                                    </section>
                                    </Col>
                                    <Col xl="6" xs="12"  className="text-left">
                                    <section>
                                    <p className="font-600 display-5">
                                    Questions this chart does NOT answer:
                                    </p>
                                    <br/>
                                    <p><span className="font600">
                                    Q. How long will the lockdowns last?
                                    </span>
                                    </p>
                                    <p>
                                    A. The graphs show you seven-day rolling averages. These averages adjust the slope of the curve on a daily basis and are affected by real-world actions such as social-distancing and quarantines. 
                                        </p>
                                        <p>
                                        <span className="font600">
                                    Be careful not to naively extrapolate values today for what will happen in the future.
                                    </span>
                                    </p>
                                    <br/>
                                    </section>
                                    </Col>
                                    </Row>
                                    </div>

                                <div className="feedbackbox feeddeath">
                                    <p className="text-center font-600 display-5">Does this chart improve your understanding of where we're heading?</p>{textselect6}
                                </div>
                                {feedquestion6}
                                    {thankyou6}
                                </Col>
                                    </Row>

                        </Container>
                    </Container>
                </div>
            )
        }
    }
    export default Part4
